var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header-global"},[_c('nav',{staticClass:"navbar"},[_c('div',{staticClass:"container"},[_c('base-switch',{attrs:{"value":this.$i18n.locale === 'jp'},on:{"onswitch":_vm.handleLanguageSwitch}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }